import { render } from "./Ambassador.vue?vue&type=template&id=35f85ae1&scoped=true"
import script from "./Ambassador.vue?vue&type=script&lang=js"
export * from "./Ambassador.vue?vue&type=script&lang=js"

import "./Ambassador.vue?vue&type=style&index=0&id=35f85ae1&lang=scss&scoped=true"
import "./Ambassador.vue?vue&type=style&index=1&id=35f85ae1&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f85ae1"]])

export default __exports__